import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

import { SPACING_UNIT } from '../../../../constant/spacing';
import _FileUploader from '../../FileUploader';
import Spinner from '../../Spinner';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const noop = () => undefined;

const AttachmentUploaderProcessing = ({ className }: Props) => (
  <Root className={className}>
    <FileUploader onRequestFileUpload={noop} />

    <SpinnerCurtain />
  </Root>
);

const Root = styled('div')({ position: 'relative' });

const FileUploader = styled(_FileUploader)({
  width: '100%',
  height: '100%',
  flexDirection: 'row',
  padding: `${SPACING_UNIT / 2}px ${SPACING_UNIT * 3}px`,
  '> *': {
    margin: `${SPACING_UNIT * 2}px ${SPACING_UNIT}px`,
  },
});

const SpinnerCurtain = styled(Spinner)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'rgba(0, 0, 0, .5)',
  borderRadius: 8,
});

export default AttachmentUploaderProcessing;
